/*
ashraf 09/21/2022 2700843951 added select fields at service type
suresh 09/21/2022 2700843951 Service Type Table Data Alignments
ashraf 09/30/2022 2700843951 debtor over payment label fix
saivika 09/30/2022 2700843951 text field width alignments
Akhilaavvaru 09/30/2022 2700843951 added filed function in add client and dashboard
saikrishna 10/03/2022 2700843951 Feature: Added three fields in multiple places wherever required in client management
ashraf 10/03/2022 2700843951 fixed alignments at service type rate card dropdowns
Akhilaavvaru 10/04/2022 2700843951 bug fix added required symbol
Akhilaavvaru 10/04/2022 2700843951 changed label for Debtor Over Payments Remitted
saikrishna 10/04/2022 2700843951 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95).
saikrishna 10/06/2022 2700843951 Removed unecesarry console.log statements
saikrishna 10/06/2022 2700843951 Fixed jira bugs in client maintenance.jira(417,18,384,263).
saimaheshwar 10/13/2022 2700843951 BugFix added scroll for add client rates
saikrishna 10/13/2022 2700843951 Fixed Gal-460 bug in Client Maintenance
saimaheshwar 10/20/2022 2700843951 fixed client maintenance UI issues
Sai Maheshwar 10-20-2022  2700843951 - fixed client maintenance dashboard UI
Suresh Peddavoora 10/30/2022 2700843951  Added Class Name for Table Enhancements
*/
import {
  Accordion,
  AccordionDetails,
  Checkbox,
  FormControl,
  InputAdornment,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import {Currency} from '../../../util/Currency';
import DateFnsUtils from '@date-io/date-fns';
import React, {memo, useCallback} from 'react';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import {withStyles} from '@material-ui/styles';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {useSelector} from 'react-redux';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'dense',
  },
  customTable: {
    'backgroundColor': '#32046926',
    'maxHeight': 'calc(80vh - 135px)',
    '& .MuiSvgIcon-root': {
      fill: 'currentColor !important',
    },
    '& .MuiCheckbox-colorPrimary.Mui-checked': {
      color: '#320469',
    },
  },
  inputStyles: {
    '& .MuiTypography-root': {
      padding: '0px !important',
    },
    '& .MuiOutlinedInput-root': {
      padding: '0px 10px',
      justifyContent: 'center',
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 3px 10px 6px',
      width: '85px',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'black !important',
    },
  },
  notesInputStyles: {
    '& .MuiInputBase-inputMultiline': {
      width: '16rem',
    },
  },
}));

const ServiceTypeAccordion = memo(({formik, serviceType, setBlockScroll, blockScroll}) => {
  const componentClasses = useStyles();
  const {
    subServiceTypes,
    serviceTypes,
  } = useSelector(({clientGeneral}) => clientGeneral);
  const {
    errors,
    values,
    setFieldValue,
    touched,
    setFieldError,
    handleBlur,
  } = formik;
  const [memorizing, setMemorizing] = React.useState('');

  const isRateCardRequired = values.companyType !== 'The WellFund, LLC';
  const isFieldDisabled = (id) => (isRateCardRequired ? false : !values[`selected${id}`]);

  const getSubServiceTypes = useCallback((id) =>
    subServiceTypes &&
    subServiceTypes.length > 0 &&
    subServiceTypes.filter((type) => type.serviceTypeId === id), [serviceTypes, subServiceTypes, memorizing, isRateCardRequired]);


  //   const AccordionSummary = styled((props) => (
  //     <MuiAccordionSummary
  //       expandIcon={<ChevronRight sx={{ fontSize: "0.9rem" }} />}
  //       {...props}
  //     />
  //   ))(({ theme }) => ({
  //     backgroundColor:
  //       theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "red",
  //     flexDirection: "row-reverse",
  //     "& .MuiAccordionSummary-expandIcon .Mui-expanded": {
  //       transform: "rotate(45deg)",
  // backgroundColor: "blue"
  //     },
  //     "& .MuiAccordionSummary-content": {
  //       marginLeft: theme.spacing(1),
  //     },
  //   }));
  const AccordionSummary = withStyles({
    root: {
      'backgroundColor': 'rgba(0, 0, 0, .03)',
      'borderBottom': '1px solid rgba(0, 0, 0, .125)',
      'marginBottom': -1,
      'flexDirection': 'row-reverse',
      'minHeight': 56,
      '&$expanded': {
        minHeight: 56,
      },
      '& .MuiAccordionSummary-content': {},
      '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
        transform: 'rotate(90deg)',
      },
    },
    content: {
      '&$expanded': {
        margin: '12px 0',
      },
    },
    expanded: {},
  })(MuiAccordionSummary);

  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ChevronRight />}
          aria-controls={`panel${serviceType?.serviceTypeId}-content`}
          id={`panel${serviceType?.serviceTypeId}-header`}
        >
          <Typography>{serviceType?.serviceType}</Typography>
        </AccordionSummary>
        <AccordionDetails className="p-0">
          <div className="w-100 " style={{overflowX: 'scroll'}}>
            <div
              className="w-100 d-flex mb-3 servicetype-table global-field-table"

            >
              <div style={{fontWeight: 'bold', minWidth: '5%'}}>Actions</div>
              <div style={{fontWeight: 'bold', minWidth: '12%'}}>
                {isRateCardRequired ? 'Service type' : 'Sub Service Type'}
              </div>
              <div style={{fontWeight: 'bold', minWidth: '15%'}}>Rate Type *</div>
              <div style={{fontWeight: 'bold', minWidth: '11%'}}>Value *</div>
              <div style={{fontWeight: 'bold', minWidth: '15%'}}>Effective Date *</div>
              <div style={{fontWeight: 'bold', minWidth: '15%'}}>End Date</div>
              <div style={{fontWeight: 'bold', minWidth: '13%', maxWidth: '14%', whiteSpace: 'pre-wrap'}}>Debtor Over Payments Remitted *</div>
              <div style={{fontWeight: 'bold', minWidth: '13%', maxWidth: '14%', whiteSpace: 'pre-wrap'}}>Inflation Agreement *</div>
              <div style={{fontWeight: 'bold', minWidth: '13%', maxWidth: '14%', whiteSpace: 'pre-wrap'}}>Postage Agreement *</div>
              <div style={{fontWeight: 'bold', minWidth: '17%'}}>Notes</div>
            </div>

            {getSubServiceTypes(serviceType?.serviceTypeId) &&
              getSubServiceTypes(serviceType?.serviceTypeId).length > 0 &&
              getSubServiceTypes(serviceType?.serviceTypeId).map((subService, i) => {
                const {subServiceTypeId, subServiceType} = subService;
                return (
                  <div
                    className="w-100 d-flex sevicetable-data"
                    key={subServiceTypeId}
                  >
                    <div style={{width: '5%'}}>
                      <Checkbox
                        color="primary"
                        checked={isRateCardRequired || values[`selected${subServiceTypeId}`]}
                        onChange={(e) => {
                          // trigger();
                          // onChange(e.target.checked);
                          if (!isRateCardRequired) {
                            setFieldValue(`selected${subServiceTypeId}`, e.target.checked);
                            setMemorizing(`selected${subServiceTypeId}`);
                            if (!e.target.checked) {
                              setFieldError(`rateType${subServiceTypeId}`, null);
                              setFieldError(`value${subServiceTypeId}`, null);
                              setFieldError(`effectiveDate${subServiceTypeId}`, null);
                              setFieldValue(`rateType${subServiceTypeId}`, 'none');
                              setFieldValue(`value${subServiceTypeId}`, '');
                              setFieldValue(`effectiveDate${subServiceTypeId}`, '');
                            }
                          }
                        }}
                      />
                      {/* <DebounceCheckBox onChange={handleChange} value={isRateCardRequired || values[`selected${subServiceTypeId}`]} setFieldValue={setFieldValue} 
                      name={`selected${subServiceTypeId}`} /> */}
                    </div>
                    <div className="subServiceData" style={{minWidth: '12%'}}>
                      {subServiceType}
                    </div>
                    <div style={{minWidth: '15%', position: 'relative'}} className="form-group">
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <Select
                          fullWidth
                          name={`rateType${subServiceTypeId}`}
                          disabled={isFieldDisabled(subServiceTypeId)}
                          // defaultValue="none"
                          value={
                            values[`rateType${subServiceTypeId}`] ?
                              values[`rateType${subServiceTypeId}`] :
                              'none'
                          }
                          onBlur={handleBlur}
                          error={errors[`rateType${subServiceTypeId}`]}
                          touched={touched && touched[`rateType${subServiceTypeId}`]}
                          onChange={(e) => {
                            setFieldValue(`rateType${subServiceTypeId}`, e.target.value);
                          }}
                        >
                          <MenuItem value="none" key="none" disabled>
                            <span className="defaultSelected">Select Any</span>
                          </MenuItem>
                          <MenuItem value="flat">Flat Fee</MenuItem>
                          <MenuItem value="percentage">Percentage</MenuItem>
                        </Select>
                      </FormControl>
                      <div className={`custom-error-text ${componentClasses.root}`} style={{width: '100%', position: 'absolute'}}>
                        {errors[`rateType${subServiceTypeId}`]}
                      </div>
                    </div>

                    <div style={{minWidth: '11%', position: 'relative'}} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        // type="number"
                        value={values[`value${subServiceTypeId}`]}
                        placeholder={`Enter Value`}
                        // className={` ${classes.labelName} ${classes.inputLabel}`}
                        // label={}
                        className={`defaultSelected ${componentClasses.inputStyles}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onBlur={handleBlur}
                        disabled={
                          isFieldDisabled(subServiceTypeId) ||
                          !values[`rateType${subServiceTypeId}`]
                        }
                        name={`value${subServiceTypeId}`}
                        // // required
                        // value={values[field.paramName]}
                        InputProps={
                          values[`rateType${[subServiceTypeId]}`] === 'flat' ?
                            {
                              startAdornment: <InputAdornment>$</InputAdornment>,
                              inputComponent: Currency,
                            } :
                            values[`rateType${[subServiceTypeId]}`] === 'percentage' ?
                              {
                                endAdornment: <InputAdornment>%</InputAdornment>,
                                inputComponent: Currency,
                              } :
                              {}
                        }
                        onChange={(e) => {
                          setFieldValue(`value${subServiceTypeId}`, e.target.value);
                        }}
                        // onBlur={handleBlur}
                        // fullWidth
                        error={errors[`value${subServiceTypeId}`]}
                        touched={touched && touched[`value${subServiceTypeId}`]}
                      />
                      <div className={`custom-error-text ${componentClasses.root}`} style={{width: '100%', position: 'absolute'}}>
                        {errors[`value${subServiceTypeId}`]}
                      </div>
                    </div>

                    <div style={{minWidth: '15%', position: 'relative'}} className="form-group">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          // className={`${classes.datePicker} ${classes.labelName}`}
                          //   className={`${componentClasses.inputStyles}`}
                          orientation="portrait"
                          onBlur={handleBlur}
                          format="MM/dd/yyyy"
                          value={
                            values[`effectiveDate${subServiceTypeId}`] ?
                              values[`effectiveDate${subServiceTypeId}`] :
                              null
                          }
                          autoOk
                          disabled={isFieldDisabled(subServiceTypeId)}
                          minDate={new Date()}
                          // minDateMessage={null}
                          name={`effectiveDate${subServiceTypeId}`}
                          inputVariant="outlined"
                          margin="dense"
                          helperText={null}
                          placeholder="MM/DD/YYYY"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(date) => {
                            setFieldValue(`effectiveDate${subServiceTypeId}`, date);
                          }}
                          error={errors[`effectiveDate${subServiceTypeId}`]}
                          touched={touched && touched[`effectiveDate${subServiceTypeId}`]}
                        // helperText={error && error.message}
                        />
                      </MuiPickersUtilsProvider>
                      <div className="custom-error-text" style={{width: '100%', position: 'absolute'}}>
                        {errors[`effectiveDate${subServiceTypeId}`]}
                      </div>
                    </div>

                    <div style={{minWidth: '15%'}} className="form-group">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          // className={`${classes.datePicker} ${classes.labelName}`}
                          //   className={`${componentClasses.inputStyles}`}
                          orientation="portrait"
                          format="MM/dd/yyyy"
                          value={
                            values[`endDate${subServiceTypeId}`] ?
                              values[`endDate${subServiceTypeId}`] :
                              null
                          }
                          disabled={
                            isFieldDisabled(subServiceTypeId) ||
                            !values[`effectiveDate${subServiceTypeId}`]
                          }
                          // defaultValue={null}
                          autoOk
                          // maxDate={maxWaitDate}
                          name={`endDate${subServiceTypeId}`}
                          inputVariant="outlined"
                          margin="dense"
                          error={errors[`endDate${subServiceTypeId}`]}
                          helperText={null}
                          placeholder="MM/DD/YYYY"
                          minDate={new Date(moment(values[`effectiveDate${subServiceTypeId}`]).add(1, 'days')
                            .format('YYYY-MM-DD'))}
                          minDateMessage={null}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(date) => {
                            setFieldValue(`endDate${subServiceTypeId}`, date);
                          }}
                        //   error={error && error.message}
                        //   helperText={error && error.message}
                        />
                      </MuiPickersUtilsProvider>
                      <div className={`custom-error-text-end-date ${componentClasses.root}`}>
                        {errors[`endDate${subServiceTypeId}`]}
                      </div>
                    </div>
                    <div style={{minWidth: '12%', maxWidth: '14%', position: 'relative'}} className="form-group">
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <Select
                          fullWidth
                          name={`debtorOverPayments${subServiceTypeId}`}
                          disabled={isFieldDisabled(subServiceTypeId)}
                          // defaultValue="none"
                          value={
                            values[`debtorOverPayments${subServiceTypeId}`] ?
                              values[`debtorOverPayments${subServiceTypeId}`] :
                              'none'
                          }
                          onBlur={handleBlur}
                          error={errors[`debtorOverPayments${subServiceTypeId}`]}
                          touched={touched && touched[`debtorOverPayments${subServiceTypeId}`]}
                          inputProps={{
                            style: {position: blockScroll ? `absolute` : ``},
                          }}
                          // onOpen={() => {
                          //   // may required
                          //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                          //   setBlockScroll(true);
                          //   // }
                          // }}
                          // onClose={() => {
                          //   // may required
                          //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                          //   setBlockScroll(false);
                          //   // }
                          // }}
                          onChange={(e) => {
                            setFieldValue(`debtorOverPayments${subServiceTypeId}`, e.target.value);
                          }}
                        >
                          <MenuItem value="none" key="none">
                            <span className="defaultSelected">Select Any</span>
                          </MenuItem>
                          <MenuItem value="send">Send</MenuItem>
                          <MenuItem value="dont send">Don&apos;t Send</MenuItem>
                        </Select>
                      </FormControl>
                      <div className={`custom-error-text w-100 ${componentClasses.root}`}>
                        {errors[`debtorOverPayments${subServiceTypeId}`]}
                      </div>
                    </div>
                    <div style={{minWidth: '12%', maxWidth: '14%', position: 'relative'}} className="form-group">
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <Select
                          fullWidth
                          name={`inflationAgreement${subServiceTypeId}`}
                          disabled={isFieldDisabled(subServiceTypeId)}
                          // defaultValue="none"
                          value={
                            values[`inflationAgreement${subServiceTypeId}`] ?
                              values[`inflationAgreement${subServiceTypeId}`] :
                              'none'
                          }
                          onBlur={handleBlur}
                          error={errors[`inflationAgreement${subServiceTypeId}`]}
                          touched={touched && touched[`inflationAgreement${subServiceTypeId}`]}
                          inputProps={{
                            style: {position: blockScroll ? `absolute` : ``},
                          }}
                          // onOpen={() => {
                          //   // may required
                          //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                          //   setBlockScroll(true);
                          //   // }
                          // }}
                          // onClose={() => {
                          //   // may required
                          //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                          //   setBlockScroll(false);
                          //   // }
                          // }}
                          onChange={(e) => {
                            setFieldValue(`inflationAgreement${subServiceTypeId}`, e.target.value);
                          }}
                        >
                          <MenuItem value="none" key="none">
                            <span className="defaultSelected">Select Any</span>
                          </MenuItem>
                          <MenuItem value="Has Agreement">Has Agreement</MenuItem>
                          <MenuItem value="No Agreement">No Agreement</MenuItem>
                        </Select>
                      </FormControl>
                      <div className={`custom-error-text w-100 ${componentClasses.root}`}>
                        {errors[`inflationAgreement${subServiceTypeId}`]}
                      </div>
                    </div>
                    <div style={{minWidth: '12%', maxWidth: '14%', position: 'relative'}} className="form-group">
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <Select
                          fullWidth
                          name={`postageAgreement${subServiceTypeId}`}
                          disabled={isFieldDisabled(subServiceTypeId)}
                          // defaultValue="none"
                          value={
                            values[`postageAgreement${subServiceTypeId}`] ?
                              values[`postageAgreement${subServiceTypeId}`] :
                              'none'
                          }
                          onBlur={handleBlur}
                          error={errors[`postageAgreement${subServiceTypeId}`]}
                          touched={touched && touched[`postageAgreement${subServiceTypeId}`]}
                          inputProps={{
                            style: {position: blockScroll ? `absolute` : ``},
                          }}
                          // onOpen={() => {
                          //   // may required
                          //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                          //   setBlockScroll(true);
                          //   // }
                          // }}
                          // onClose={() => {
                          //   // may required
                          //   // if (serviceTypeId === 30 || serviceTypeId === 31) {
                          //   setBlockScroll(false);
                          //   // }
                          // }}
                          onChange={(e) => {
                            setFieldValue(`postageAgreement${subServiceTypeId}`, e.target.value);
                          }}
                        >
                          <MenuItem value="none" key="none">
                            <span className="defaultSelected">Select Any</span>
                          </MenuItem>
                          <MenuItem value="Has Agreement">Has Agreement</MenuItem>
                          <MenuItem value="No Agreement">No Agreement</MenuItem>
                        </Select>
                      </FormControl>
                      <div className={`custom-error-text w-100 ${componentClasses.root}`}>
                        {errors[`postageAgreement${subServiceTypeId}`]}
                      </div>
                    </div>
                    <div style={{minWidth: '18%'}} className="form-group">
                      <TextField
                        // label="Multiline"
                        margin="dense"
                        variant="outlined"
                        disabled={isFieldDisabled(subServiceTypeId)}
                        // className={`${componentClasses.notesInputStyles}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Enter your note here"
                        multiline
                        maxRows={4}
                        error={errors[`rateNote${subServiceTypeId}`]}
                        name={`rateNote${subServiceTypeId}`}
                        value={values[`rateNote${subServiceTypeId}`]}
                        onChange={(e) => {
                          setFieldValue(`rateNote${subServiceTypeId}`, e.target.value);
                        }}
                      />
                      <div style={{color: 'red'}} className={componentClasses.root}>
                        {errors[`rateNote${subServiceTypeId}`]}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
});

ServiceTypeAccordion.displayName = 'ServiceTypeAccordion';
export default ServiceTypeAccordion;
